<script>
  import { createEventDispatcher } from 'svelte';
  import request from 'superagent';
  
  const dispatch = createEventDispatcher();
  const defaultVideo = { id: null, video_id: null, language: "cz", title: "", uri: "", channel_name: "", image: ""}
  
  export let item_id = null;
  export let video = Object.assign({}, defaultVideo);
  export let show_label = false;
  
  export function commit() {
      let call = video.id ? request.put : request.post;
      call(`/form/${window.VIDEO_FORM_ID}`)
      .send(Object.assign({item_id: item_id}, video))
      .then(resp => {
        video.id = resp.body.id;
        dispatch("video", video);
      })
      .catch(resp => {
        console.log("problem detected in when commiting")
      });
  }
  
  function getInfo() {
    if (video.uri == "") {
      return;
    }
    request.get(`/p/video.json?uri=`+video.uri)
    .then(resp => {
      // todo video.slug usage
      video.video_id = resp.body.id;
      video.image = resp.body.image;
      video.channel_name = resp.body.about;
      if (video.title == "")
        video.title = resp.body.title;
    })
  }
  
  function remove() {
    dispatch('remove');
  }
</script>
<form action='/form/{window.VIDEO_FORM_ID}'>
{#if show_label}
<div class='row'>
<div class='col-12 col-sm-6 col-md-4'>
<label class='form-text text-muted' for='item-video-uri'>Video</label>
</div>
<div class='col-12 col-sm-6 col-md-4'>
<label class='form-text text-muted' for='item-video-title'>Titulek</label>
</div>
</div>
{/if}
<div class='row item-video'>
{#if video.video_id && video.image}
<div class='col-12 col-md-4 p-1'>
<img alt='{video.title}' class='img-fluid' src='{video.image}'>
</div>
{:else}
<fieldset class='form-group col-12 col-md-4'>
<textarea bind:value='{video.uri}' class='form-control w-100 underline-input' id='item-video-uri' on:blur='{() => getInfo()}' placeholder='http://...' rows='3'></textarea>
</fieldset>
{/if}
<div class='col-12 col-md-8'>
<fieldset class='form-group'>
<input bind:value='{video.title}' class='form-control w-100 underline-input' id='item-video-title' placeholder='...'>
</fieldset>
<div class='d-flex justify-content-between flex-row'>
<select bind:value='{video.language}' class='form-control w-auto border-0 underline-input' id='item-video-language'>
<option></option>
<option>cz</option>
<option>en</option>
<option>sk</option>
<option>ru</option>
</select>
<div class='justify-content-start'>
{#if item_id}
<button class='btn btn-outline-primary border-0 d-inline-block btn-smlr' on:click|preventDefault='{() => commit()}' title='Uložit'>
<i class='fa fa-save'></i>
<div class='d-none d-xl-inline'>
Uložit
</div>
</button>
{/if}
<button class='btn btn-outline-danger border-0 d-inline-block btn-smlr' on:click|preventDefault='{remove}' title='Smazat'>
<i class='fa fa-times'></i>
</button>
</div>
</div>
</div>
</div>
</form>

